import { ReactNode } from 'react';
import styled from 'styled-components';

import { useClickAttachment } from 'hooks/useClickAttachment';
import Upload from 'hooks/useDirectUpload/Upload';
import Attachment from 'models/Attachment';

// "entry" can be an object where the "id" prop is a number or a GUID. We only
// want to make the link clickable and fetch the attachment if the "id" prop
// is a GUID.
const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

type DocumentLinkInput = {
  backgroundColor?: string;
  children: Iterable<ReactNode> | ReactNode;
  entry: Attachment | Upload;
};

export default function DocumentLink(props: DocumentLinkInput) {
  const { backgroundColor, entry, children } = props;

  const openAttachment = useClickAttachment(entry.id);

  const handleClick = () => {
    if (!guidRegex.test(entry.id)) return;

    openAttachment();
  };

  return (
    <Link backgroundColor={backgroundColor} onClick={handleClick} clickable={guidRegex.test(entry.id)}>
      {children}
    </Link>
  );
}

const Link = styled.a<{
  backgroundColor?: string;
  clickable: boolean;
}>`
  display: block;
  cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
`;
